const movementType = {
  RECEIVEMENT: 'Recebimento',
  DAMAGED: 'Dano',
  ADJUSTMENT: 'Ajuste',
  CHECKOUT: 'Checkout',
  REFUND: 'Estorno',
  EXPIRED_DUE_DATE: 'Validade',
  MATURATION: 'Amadurecimento',
  RESTOCK: 'Abastecimento',
}

const movementTypeForTab = {
  ...movementType,
  'ADJUSTMENT (+)': 'Ajuste (+)',
  'ADJUSTMENT (-)': 'Ajuste (-)',
}

export const mapMovementType = (key: string) => movementType[key] || 'Desconhecido'

export const mapMovementTypeForTab = (key: string) => movementTypeForTab[key] || 'Desconhecido'
